'use client'

import type { Editor } from '@tiptap/react'
import { textFormattingButtons } from './editor-toolbar.config'
import { EditorToolbarButtonGroup } from './editor-toolbar-button-group.atom'

export interface EditorToolbarTextFormattingProps {
  editor: Editor
  isDisabled?: boolean
}

/**
 * Text formatting buttons section (bold, italic, underline, etc.)
 */
export const EditorToolbarTextFormatting = ({
  editor,
  isDisabled = false,
}: EditorToolbarTextFormattingProps) => (
  <EditorToolbarButtonGroup
    editor={editor}
    buttonList={textFormattingButtons}
    isDisabled={isDisabled}
  />
)

EditorToolbarTextFormatting.displayName = 'EditorToolbarTextFormatting'
